import { Box } from "@chakra-ui/react";
import React from "react";
import Header from "../../../../components/header";
import Footer from "../../../../components/footer";
import Banner from "./components/banner";
import DownloadGuide from "./components/downloadGuide";
const DownloadPageIm = () => {
  return (
    <Box>
      <Header />
      <Banner />
      <DownloadGuide />
      <Footer />
    </Box>
  );
};

export default DownloadPageIm;
